import { render, staticRenderFns } from "./ReviewObservationTable.vue?vue&type=template&id=62039e04&scoped=true&"
import script from "./ReviewObservationTable.vue?vue&type=script&lang=js&"
export * from "./ReviewObservationTable.vue?vue&type=script&lang=js&"
import style0 from "./ReviewObservationTable.vue?vue&type=style&index=0&id=62039e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62039e04",
  null
  
)

export default component.exports